import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useAuth } from '../../contexts/AuthContext';
import { bottomTabs } from './navConfig';

// Mobile-only fixed bottom navigation (< lg). Exactly 5 tabs, one-tap access.
// Active color: #006030. Respects safe-area-inset-bottom via CSS var.
const BottomNav = ({ badges = {} }) => {
  const location = useLocation();
  const { user } = useAuth();

  const resolvePath = (item) => {
    if (item.authAware && !user) return '/auth';
    return item.path;
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E2E8F0] z-50 lg:hidden safe-area-bottom"
      data-testid="bottom-tab-bar"
      aria-label="Navegação principal"
    >
      <div className="flex items-stretch justify-around h-16 max-w-md mx-auto">
        {bottomTabs.map((item) => {
          const Icon = item.icon;
          const to = resolvePath(item);
          const isActive =
            item.path === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.path);
          const badge = item.badgeKey ? badges[item.badgeKey] || 0 : 0;
          return (
            <Link
              key={item.key}
              to={to}
              data-testid={item.testId}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 px-2 rounded-lg transition-colors duration-200 relative min-w-[56px]',
                isActive ? 'text-[#006030]' : 'text-[#94A3B8] hover:text-[#006030]',
              )}
            >
              <div className="relative">
                <Icon className={cn('w-6 h-6 transition-all', isActive && 'stroke-[2.5px]')} />
                {badge > 0 && (
                  <span
                    className="absolute -top-1.5 -right-2 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-[#C62828] text-white text-[9px] font-bold px-1"
                    data-testid={`${item.testId}-badge`}
                  >
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className={cn('text-[10px] font-medium leading-tight', isActive && 'font-bold')}>
                {item.label}
              </span>
              {isActive && (
                <span className="absolute -bottom-0.5 w-6 h-0.5 bg-[#006030] rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
